let messages = {
   
    email: 'Email není správný',
    required: 'Toto pole nemůže být prázdné',
    numeric: 'Toto pole nmusí být číslo',
    default: 'Toto pole není validní'
   
};

export default messages;